import type { FC } from 'react';

import MarqueNotification from './components/Marquee';
import { StandardNotification } from './components/Standard';
import { StickyNotification } from './components/Sticky';
import type { INotificationBanner, notificationType } from './NotificationBanner.helpers';

const NotificationBanner = ({ type, data, message, status, buttonTitle, onButtonClick, onCancel }: INotificationBanner) => {
	const componentObj: Record<notificationType, FC<INotificationBanner>> = {
		marquee: MarqueNotification,
		standard: StandardNotification,
		sticky: StickyNotification,
	};

	const Component = componentObj[type];

	return (
		<Component
			data={data}
			status={status}
			message={message}
			buttonTitle={buttonTitle}
			onButtonClick={onButtonClick}
			onCancel={onCancel}
			type={type}
		/>
	);
};

export default NotificationBanner;
